import React, { useState, useEffect, useRef, useContext } from "react";
import { Button, ConfirmDialog, Dialog, InputText, Toast } from "primereact";
import { Checkbox } from "primereact/checkbox";
import { useForm } from "../../../../Base/Hooks/useForm";
import { toastShow } from "../../../../Base/Services/ToastService";
import Loader from "../../../../Base/Components/Loader/Loader";
import { AuthContext } from "../../../../Base/Context/AuthContext/AuthContext";
import { EditarTurno, GuardarTurno } from "../../../../API/RRHH/Maestros/MaestrosRequest";
import { Calendar } from "primereact/calendar";
import { DateTime, Duration } from 'luxon';

const TurnosCRUD = ({
  showDialog,
  setShowDialog,
  getInfo,
  selected,
  setSelected,
  modo
}) => {
  const toast = useRef(null);

  const { userAuth } = useContext(AuthContext);
  const [loading, setLoading] = useState(false);
  const [HoraEntrada, setHoraEntrada] = useState(null);
  const [HoraSalida, setHoraSalida] = useState(null);
  const [HoraEntradaV, setHoraEntradaV] = useState(null);
  const [HoraSalidaV, setHoraSalidaV] = useState(null);

  const initialValues = {
    IdTurno: -1,
    Turno: "",
    Descripcion: "",
    IdStatus: selected ? selected?.IdStatus  : 5,
  };

  const { values, handleInputChange, setValues, resetForm, error, setError } = useForm(initialValues);

  const getValoresIniciales = async () => {
    setLoading(true);

    if(selected[0]?.IdTurno > 0){
      setValues({
        ...selected[0],
      });

      const duracion = Duration.fromObject({ hours: 6, minutes: 0, seconds: 0 });
      setHoraEntrada(new Date(DateTime.fromJSDate(new Date(selected[0]?.HoraEntrada)).plus(duracion).toJSDate()))
      setHoraSalida(new Date(DateTime.fromJSDate(new Date(selected[0]?.HoraSalida)).plus(duracion).toJSDate()))
      setHoraEntradaV(new Date(DateTime.fromJSDate(new Date(selected[0]?.HoraEntradaV)).plus(duracion).toJSDate()))
      setHoraSalidaV(new Date(DateTime.fromJSDate(new Date(selected[0]?.HoraSalidaV)).plus(duracion).toJSDate()))
    }else{
      setValues(initialValues);
    }

    setLoading(false);
  };

  const onHide = () => {
    setShowDialog(false);
    getInfo()
    setSelected([])
    resetForm();
  };

  const verificarInfo = () => {
    let error = {};
    if (!values.Turno) {
      error.Turno = true;
      error.error = true;
    }
    if(!HoraEntrada){
        error.HoraEntrada = true;
        error.error = true;
    }
    if(!HoraSalida){
        error.HoraSalida = true;
        error.error = true;
    }

    if(values?.DiferenteHorario){
        if(!HoraEntradaV){
            error.HoraEntradaV = true;
            error.error = true;
        }
        if(!HoraSalidaV){
            error.HoraSalidaV = true;
            error.error = true;
        }
    }

    setError(error);
    return error;
  };

  const agregarPlanilla = async () => {
    const e = verificarInfo();

    if (!e.error) {

        if (HoraEntrada >= HoraSalida) {
            toastShow(toast, 'error', 'Error', 'La hora de entrada debe ser menor que la hora de salida')
            return;
        }
        
        if (values?.DiferenteHorario && HoraEntradaV >= HoraSalidaV) {
            toastShow(toast, 'error', 'Error', 'La hora de entrada debe ser menor que la hora de salida')
            return;
        }

        const horaEntrada = HoraEntrada.toLocaleTimeString('en-GB', { hour12: false });
        const horaSalida = HoraSalida.toLocaleTimeString('en-GB', { hour12: false });
        
        const horaEntradaV = HoraEntradaV.toLocaleTimeString('en-GB', { hour12: false });
        const horaSalidaV = HoraSalidaV.toLocaleTimeString('en-GB', { hour12: false });


      const Datos = {
        IdTurno: selected[0]?.IdTurno ? selected[0]?.IdTurno : -10,
        Turno: values?.Turno,
        Descripcion: values?.Descripcion,
        DiferenteHorario: values?.DiferenteHorario,
        HoraEntrada: horaEntrada,
        HoraSalida: horaSalida,
        HoraEntradaV: values?.DiferenteHorario ? horaEntradaV : null,
        HoraSalidaV: values?.DiferenteHorario ? horaSalidaV : null,
        IdUserEdit: userAuth?.IdUser,
      };

      console.log(Datos);
      if(Datos.IdTurno > 0){
        setLoading(true)
        const resultado = await EditarTurno(Datos);
        if(resultado[0]?.ESTADO === 1){
          toastShow(toast,"success","Datos Editados",resultado[0]?.MENSAJE );
          getInfo()
          setTimeout(() => {
            onHide();
            setLoading(false)
          }, 1300);
        }else{
          toastShow(toast,"error","Error",resultado[0]?.MENSAJE);
        }
      }else{
        const resultado = await GuardarTurno(Datos);
        if(resultado[0]?.ESTADO === 1){
          toastShow( toast, "success", "Datos Agregados", resultado[0]?.MENSAJE);
          getInfo()
          setTimeout(() => {
            onHide();
            setLoading(false)
          }, 1300);
        }else{
          toastShow(toast,"error","Error",resultado[0]?.MENSAJE);
        }
      }
    }
  };

  const DialogFooter = (
    <React.Fragment>
      <Button
        label="Cancelar"
        icon="pi pi-times"
        className="p-button-text"
        onClick={onHide}
      />
      <Button
        label={modo === "Crear" ? "Guardar" : "Editar"}
        icon="pi pi-check"
        className="p-button-text"
        onClick={() => {agregarPlanilla();}}
      />
    </React.Fragment>
  );

  useEffect(() => {
    if (showDialog) {
      getValoresIniciales();
    }
  }, [showDialog]);

  const dialogTitle = modo === "Crear" ? "Agregar Turno" : "Editar Turno";

  return (
    <div>
      <Dialog
        visible={showDialog}
        footer={DialogFooter}
        onHide={onHide}
        header={dialogTitle}
        style={{ width: '50%'}}
      >
        <Toast ref={toast} />
        <div id="Dialog">
          <Loader loading={loading} querySelector={"#Dialog"} />
          <div>
            <div className="d-flex mx-4">
              <div div className="field col-6 me-2 mt-2">
                <span className="p-float-label">
                  <InputText
                    name="Turno"
                    value={values.Turno}
                    onChange={handleInputChange}
                    style={{ width: "100%" }}
                    className={error.Turno ? "p-invalid" : ""}
                  />
                  <label htmlFor="Turno">Turno</label>
                </span>
              </div>

              <div className="field col-6 me-2  mt-2">
                <span className="p-float-label">
                  <InputText
                    name="Descripcion"
                    value={values.Descripcion}
                    onChange={handleInputChange}
                    style={{ width: "100%" }}
                    className={error.Descripcion ? "p-invalid" : ""}
                  />
                  <label htmlFor="Descripcion">Descripción</label>
                </span>
              </div>

            </div>

            <div className="d-flex mx-4">
                <div className="field col-6 me-2  mt-2">
                    <span className="p-float-label">
                        <Calendar
                            value={HoraEntrada}
                            onChange={(e) => setHoraEntrada(e.value)}
                            timeOnly
                            style={{width: '100%'}}
                            hourFormat="12"
                            showIcon 
                            className={error.HoraEntrada ? "p-invalid" : ""}
                        />
                        <label htmlFor="HoraEntrada">HoraEntrada</label>
                    </span>
                </div>

              <div className="field col-6 me-2 mt-2">
                    <span className="p-float-label">
                        <Calendar
                            value={HoraSalida}
                            onChange={(e) => setHoraSalida(e.value)}
                            timeOnly
                            style={{width: '100%'}}
                            hourFormat="12"
                            className={error.HoraSalida ? "p-invalid" : ""}
                            showIcon 
                        />
                        <label htmlFor="HoraSalida">Hora Salida</label>
                    </span>
              </div>

            </div>

            <div className="d-flex mx-4">
                <div className="field col-6 me-2  mt-2">
                    <span className="p-float-label">
                        <Checkbox
                          id="DiferenteHorario"
                          name="DiferenteHorario"
                          checked={values.DiferenteHorario}
                          onChange={handleInputChange}
                        />
                        <span className="mx-2 mt-4">¿Tiene diferente horario el viernes?</span>
                    </span>
                </div>
            </div>


            {values?.DiferenteHorario && (
                <div className="d-flex mx-4 mt-2">
                    <div className="field col-6 me-2  mt-2">
                        <span className="p-float-label">
                            <Calendar
                                value={HoraEntradaV}
                                onChange={(e) => setHoraEntradaV(e.value)}
                                timeOnly
                                style={{width: '100%'}}
                                className={error.HoraEntradaV ? "p-invalid" : ""}
                                hourFormat="12"
                                showIcon 
                            />
                            <label htmlFor="HoraEntradaV">Hora Entrada Viernes</label>
                        </span>
                    </div>

                    <div className="field col-6 me-2 mt-2">
                        <span className="p-float-label">
                            <Calendar
                                value={HoraSalidaV}
                                onChange={(e) => setHoraSalidaV(e.value)}
                                className={error.HoraSalidaV ? "p-invalid" : ""}
                                timeOnly
                                style={{width: '100%'}}
                                hourFormat="12"
                                showIcon 
                            />
                            <label htmlFor="HoraSalidaV">Hora Salida Viernes</label>
                        </span>
                    </div>

                </div>
            )}


          </div>
        </div>
      </Dialog>

      
    </div>
  );
};

export default TurnosCRUD;
